<template>
  <div class="grid-y align-middle align-justify padding-top-xxl padding-bottom-xxxl">
    <p>Sorry, this page is no longer available.</p>
    <div class="margin-top-m grid-y">
      <button
        class="emphasis button"
        @click="redirectBack(referrer)"
      >
        Continue Shopping
      </button>
    </div>
  </div>
</template>

<script setup>
import { redirectBack } from '../utils/redirectBack';
import { usePageData } from '../composables/usePageData';

const { referrer } = usePageData();
</script>
